import styled from 'styled-components';

export const StickyButtonArea = styled.div`
  position: fixed;
  bottom: 80px;
  right: 20px;
  z-index: 999;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.3s ease-in-out;
  pointer-events: none;

  &.visible {
    opacity: 1;
    transform: translateY(0);
    pointer-events: all;
  }

  .sticky-btn {
    display: flex;
    align-items: center;
    gap: 10px;
    background: linear-gradient(135deg, rgb(242, 128, 0) 0%, #e57706 100%);
    color: #fff;
    padding: 14px 24px;
    border-radius: 50px;
    box-shadow: 0 4px 15px rgba(242, 128, 0, 0.4);
    text-decoration: none;
    font-weight: 600;
    font-size: 16px;
    transition: all 0.3s ease;

    i {
      font-size: 20px;
    }

    span {
      @media (max-width: 480px) {
        display: none;
      }
    }

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 6px 20px rgba(242, 128, 0, 0.5);
      background: linear-gradient(135deg, #e57706 0%, rgb(242, 128, 0) 100%);
    }

    &:active {
      transform: translateY(-1px);
    }
  }

  @media (max-width: 480px) {
    bottom: 20px;
    right: 20px;

    .sticky-btn {
      width: 56px;
      height: 56px;
      padding: 0;
      justify-content: center;
      border-radius: 50%;

      i {
        margin: 0;
      }
    }
  }
`;
